{
  "accept": "*",
  "wrongType": "上傳檔案須 ${accepts} 格式!",
  "dropDown": "點選顯示所有附件檔",
  "uploadIcon": "fas fa-upload",
  "uploadText": "瀏覽",
  "uploadTooltip": "選擇上傳檔案",
  "removeIcon": "fa-solid fa-trash",
  "removeText": "確定移除 {file} 嗎?",
  "removeTooltip": "移除",
  "exceedLimit": "選擇的上傳檔案超過限制數量:",
  "removePrompt": "確定移除 {file} 嗎??"
}